<template>
  <div class="flex flex-col items-center font-semibold text-white">
    <circle-icon />
    <h3 class="text-2xl mt-8">Transaction Processing</h3>
    <p style="word-break: normal" class="text-xs font-normal my-2">
      Your payment of ${{ amount }} {{ name }} was successful.
    </p>
    <p style="word-break: normal" class="font-light text-xs text-center mt-10">
      "Every artwork comes with a handwritten note and a wish from us to you,
      you are awesome."
    </p>
    <o-button class="mt-10">Close Checkout</o-button>
  </div>
</template>

<script>
export default {
  data () {
    return {
      amount: '2000',
      name: 'Silake.ng'
    }
  },
  components: {
    CircleIcon: () => import('@/assets/icons/CircleIcon.vue')
  }
}
</script>

<style></style>
